import Vue from 'vue';
import VueRouter from 'vue-router';
import Dashboard from '../views/Dashboard';
import StatisticPage from '../views/Statistic';
import UsersPage from '../views/Users';
import UsersAdminPage from '../views/UsersAdmin';
import UserDeletedPage from '../views/UserDeleted';
import UsersPremiumPage from '../views/UsersPremium';
import ArtistsPage from '../views/Artists';
import ArtistsBioPage from '../views/ArtistBio';
import AlbumPage from '../views/Album';
// import PaidMusic from '../views/PaidMusic';
import SongManagement from '../views/contents/SongManagement';
import ProfilePage from '../views/Profile';
import Signup from '../views/Signup';
import Signin from '../views/Signin';
import SigninAdmin from '../views/SigninAdmin';
import VerificationEmail from '../views/VerificationEmail';
import SignupSuccess from '../views/SignupSuccess';
import ForgotPassword from '../views/ForgotPassword';
import ChangePassword from '../views/ChangePassword';
import SendVerification from '../views/SendVerification';
import TncManagement from '../views/TncManagement';
import IapManagement from '../views/IapManagement';
import TransactionPage from '../views/Transactions';
import WithdrawRequestPage from '../views/WithdrawRequest';
import WithdrawHistoryPage from '../views/WithdrawHistory';
import PayoutListPage from '../views/PayoutList';
import PayoutDashboardPage from '../views/PayoutDashboard';
// import WalletPage from '../views/Wallet';
import ReportPage from '../views/Report';
import ChangePasswordUser from '../views/ChangePasswordUser';
import CreditsAmount from '../views/CreditsAmount';
import TransactionHistory from '../views/TransactionHistory';
import StreamList from '../views/StreamList';
import RevenueList from '../views/RevenueList';
import PurchaseHistory from '../views/PurchaseHistory';
import PurchaseList from '../views/PurchaseList';
import SubscriptionHistory from '../views/SubscriptionHistory';
import SubscriptionSetting from '../views/SubscriptionSetting';
import SubscriptionVerifyStudent from '../views/SubscriptionVerifyStudent';
import SubscriptionVerifyStudentHistory from '../views/SubscriptionVerifyStudentHistory';
import CreditPurchase from '../views/CreditPurchase';
import RedemptionHistory from '../views/RedemptionHistory';
import Earning from '../views/Earning';
import AddArtistPage from '../views/ArtistContent/AddArtist';
import ArtistDetailPage from '../views/ArtistContent/ArtistDetail';
import ArtistDraftPage from '../views/ArtistContent/ArtistDraft';
import ArtistOnboardingPage from '../views/ArtistContent/ArtistOnboarding';
import ArtistApplicationDetailPage from '../views/ArtistContent/ArtistApplicationDetail';

// App Setting
import DailyPremiumAccessPage from '../views/AppSetting/DailyPremiumAccess';
import AdsSettings from '../views/AppSetting/AdsSettings';
// import SkipQuotaSettings from '../views/AppSetting/SkipQuotaSettings';
import AccountDeletionSurvey from '../views/AppSetting/AccountDeletionSurvey';
import HomeSection from '../views/AppSetting/HomeSection';
import OnboardingBanner from '../views/AppSetting/OnboardingBanner';
import ReferralBanner from '../views/AppSetting/ReferralBanner';
import ReferralAbout from '../views/AppSetting/ReferralAbout';

// Playlist
import ListPlaylist from '../views/Playlist/List';
import AddPlaylist from '../views/Playlist/Add';
import EditPlaylist from '../views/Playlist/Edit';

// Rating and Survey
import RatingList from '../views/RatingSurvey/RatingList';
import SurveyList from '../views/RatingSurvey/SurveyList';

// Missions Videos
import ChannelListPage from '../views/MissionsVideos/Channel/ChannelList';
import ChannelDetailPage from '../views/MissionsVideos/Channel/ChannelDetail';
import RecommendedVideosPage from '../views/MissionsVideos/Videos/RecommendedVideos';
import ChannelCreatePlaylist from '../views/MissionsVideos/Channel/CreatePlaylist';
import ChannelEditPlaylist from '../views/MissionsVideos/Channel/EditPlaylist';
import VideoPageSection from '../views/MissionsVideos/VideoPage/VideoPageSection.vue';
import VideoPageDetail from '../views/MissionsVideos/VideoPage/VideoPageDetail.vue';

import Layout from '@/components/Layout/Layout';

// Categories
import MusicCategoriesPage from '../views/Categories/MusicCategories';
import MissionCategoriesPage from '../views/Categories/MissionCategories';
import HomeSectionDetail from '@/views/AppSetting/HomeSectionDetail.vue';

// Referral Data
import ReferralDataBanner from '@/views/ReferralData/ReferralDataBanner.vue';
import ReferralDataShare from '@/views/ReferralData/ReferralDataShare.vue';
import ReferralDataMember from '@/views/ReferralData/ReferralDataMember.vue';

// Subscription
import FirstTimeSubs from '@/views/Subscription/FirstTimeSubs.vue';
import CancelExpireSubs from '@/views/Subscription/CancelExpireSubs.vue';

// CLTV

import CLTVPage from '@/views/CLTV';

Vue.use(VueRouter);

const ROLE = {
  OPS: 'operation',
  REVIEWER: 'review_committee',
  RECRUITMENT: 'recruitment',
  FINANCE: 'finance',
  ADMINISTRATOR: 'admin',
  SUPERADMIN: 'superadmin',
  ARTIST: 'artist',
};

const routes = [
  {
    path: '/',
    redirect: '/statistic',
    name: 'Dashboard',
    component: Layout,
    children: [
      {
        path: '/statistic',
        name: 'Statistic',
        component: StatisticPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.ARTIST, ROLE.REVIEWER, ROLE.RECRUITMENT] },
      },
      {
        path: '/users',
        name: 'Users',
        component: UsersPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      }, {
        path: '/users-admin',
        name: 'UsersAdmin',
        component: UsersAdminPage,
        meta: { authorize: [ROLE.SUPERADMIN] },
      }, {
        path: '/users-deleted',
        name: 'UsersDeletedPage',
        component: UserDeletedPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      }, {
        path: '/users-premium',
        name: 'UsersPremium',
        component: UsersPremiumPage,
        meta: { authorize: [ROLE.ADMINISTRATOR, ROLE.SUPERADMIN] },
      },
      {
        path: '/artists',
        name: 'Artists',
        component: ArtistsPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.RECRUITMENT] },
      },
      {
        path: '/album',
        name: 'Album',
        component: AlbumPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.ARTIST, ROLE.REVIEWER, ROLE.RECRUITMENT] },
      },
      {
        path: '/song-management',
        name: 'SongManagement',
        component: SongManagement,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.REVIEWER, ROLE.RECRUITMENT] },
      },
      {
        path: '/tnc-management',
        name: 'TncManagement',
        component: TncManagement,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/iap-management',
        name: 'IapManagement',
        component: IapManagement,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/profile',
        name: 'Profile',
        component: ProfilePage,
        meta: { authorize: ['*'] },
      },
      {
        path: '/purchase-history',
        name: 'Transactions',
        component: TransactionPage,
        meta: { authorize: [ROLE.ARTIST] },
      },
      {
        path: '/withdraw-request',
        name: 'WithdrawRequest',
        component: WithdrawRequestPage,
        meta: { authorize: ['*'] },
      },
      {
        path: '/payout-list',
        name: 'PayoutList',
        component: PayoutListPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.FINANCE] },
      },
      {
        path: '/payout-dashboard',
        name: 'PayoutDashboard',
        component: PayoutDashboardPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.FINANCE] },
      },
      {
        path: '/transfer-history',
        name: 'TransferHistory',
        component: WithdrawHistoryPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.FINANCE] },
      }, {
        path: '/report',
        name: 'Report',
        component: ReportPage,
        meta: { authorize: [ROLE.ARTIST] },
      }, {
        path: '/change-password-user',
        name: 'ChangePasswordUser',
        component: ChangePasswordUser,
        meta: { authorize: ['*'] },
      }, {
        path: '/artist-bio',
        name: 'ArtistsBio',
        component: ArtistsBioPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.RECRUITMENT, ROLE.REVIEWER] },
      }, {
        path: '/credits-amount',
        name: 'CreditsAmount',
        component: CreditsAmount,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.RECRUITMENT, ROLE.REVIEWER] },
      }, {
        path: '/transaction-history',
        name: 'TransactionHistoryPage',
        component: TransactionHistory,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      }, {
        path: '/stream-list',
        name: 'StreamListPage',
        component: StreamList,
        meta: { authorize: [ROLE.ARTIST] },
      }, {
        path: '/revenue-list',
        name: 'RevenueListPage',
        component: RevenueList,
        meta: { authorize: ['*'] },
      }, {
        path: '/purchase-history-old',
        name: 'PurchaseHistoryPage',
        component: PurchaseHistory,
        meta: { authorize: ['*'] },
      }, {
        path: '/purchase-list',
        name: 'PurchaseListPage',
        component: PurchaseList,
        meta: { authorize: [ROLE.ARTIST] },
      }, {
        path: '/subscription-history',
        name: 'SubscriptionHistoryPage',
        component: SubscriptionHistory,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      }, {
        path: '/subscription-setting',
        name: 'SubscriptionSettingPage',
        component: SubscriptionSetting,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      }, {
        path: '/subscription-verify-student',
        name: 'SubscriptionVerifyStudentPage',
        component: SubscriptionVerifyStudent,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      }, {
        path: '/subscription-verify-student-history',
        name: 'SubscriptionVerifyStudentHistoryPage',
        component: SubscriptionVerifyStudentHistory,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      }, {
        path: '/credit-purchase',
        name: 'CreditPurchasePage',
        component: CreditPurchase,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      }, {
        path: '/redemption-history',
        name: 'RedemptionHistoryPage',
        component: RedemptionHistory,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      }, {
        path: '/earning',
        name: 'EarningPage',
        component: Earning,
        meta: { authorize: [ROLE.ARTIST] },
      }, {
        path: '/artists/add',
        name: 'AddArtistPage',
        component: AddArtistPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.RECRUITMENT] },
      },
      {
        path: '/artists/detail/:id',
        name: 'DetailArtistPage',
        component: ArtistDetailPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.RECRUITMENT] },
      },
      {
        path: '/artists/draft',
        name: 'DraftArtistPage',
        component: ArtistDraftPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.RECRUITMENT] },
      },
      {
        path: '/artists/onboarding',
        name: 'ArtistOnboardingPage',
        component: ArtistOnboardingPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.RECRUITMENT] },
      },
      {
        path: '/artists/onboarding/:id',
        name: 'ArtistApplicationDetailPage',
        component: ArtistApplicationDetailPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR, ROLE.RECRUITMENT] },
      },
      // App Setting
      // App Setting - Daily Premium Access
      {
        path: '/app-setting/daily-premium-access',
        name: 'DailyPremiumAccessPage',
        component: DailyPremiumAccessPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/app-setting/add-settings',
        name: 'AdsSettings',
        component: AdsSettings,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/app-setting/account-deletion-survey',
        name: 'AccountDeletionSurvey',
        component: AccountDeletionSurvey,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/app-setting/home-section',
        name: 'HomeSection',
        component: HomeSection,
        meta: { authorize: [ROLE.OPS,ROLE.SUPERADMIN,ROLE.ADMINISTRATOR, ROLE.REVIEWER] },
      },
      {
        path: '/app-setting/home-section/:sectionId',
        name: 'HomeSectionDetail',
        component: HomeSectionDetail,
        meta: { authorize: [ROLE.OPS,ROLE.SUPERADMIN,ROLE.ADMINISTRATOR, ROLE.REVIEWER] },
      },
      {
        path: '/app-setting/onboarding-banner',
        name: 'OnboardingBanner',
        component: OnboardingBanner,
        meta: { authorize: [ROLE.OPS,ROLE.SUPERADMIN,ROLE.ADMINISTRATOR] },
      },{
        path: '/app-setting/referral-banner',
        name: 'ReferralBanner',
        component: ReferralBanner,
        meta: { authorize: [ROLE.OPS,ROLE.SUPERADMIN,ROLE.ADMINISTRATOR] },
      },{
        path: '/app-setting/referral-about',
        name: 'ReferralAbout',
        component: ReferralAbout,
        meta: { authorize: [ROLE.OPS,ROLE.SUPERADMIN,ROLE.ADMINISTRATOR] },
      },

      // Playlist
      {
        path: '/playlist',
        name: 'ListPlaylist',
        component: ListPlaylist,
        meta: { authorize: [ROLE.REVIEWER, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/playlist/add',
        name: 'AddPlaylist',
        component: AddPlaylist,
        meta: { authorize: [ROLE.REVIEWER, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/playlist/edit/:id',
        name: 'EditPlaylist',
        component: EditPlaylist,
        meta: { authorize: [ROLE.REVIEWER, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },

      // Rating and Survey
      {
        path: '/rating-list',
        name: 'RatingList',
        component: RatingList,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/survey-list',
        name: 'SurveyList',
        component: SurveyList,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },

      // Missions Videos
      {
        path: '/missions-videos',
        name: 'ChannelListPage',
        component: ChannelListPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/missions-videos/channel-detail/:channelId',
        name: 'ChannelDetailPage',
        component: ChannelDetailPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/missions-videos/channel-detail/create-playlist/:channelId',
        name: 'ChannelCreatePlaylistPage',
        component: ChannelCreatePlaylist,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/missions-videos/channel-detail/edit-playlist/:channelId/:id',
        name: 'ChannelEditPlaylistPage',
        component: ChannelEditPlaylist,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/missions-videos/recommended',
        name: 'RecommendedVideosPage',
        component: RecommendedVideosPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/missions-videos/video-page',
        name: 'VideoPageSection',
        component: VideoPageSection,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/missions-videos/video-page/detail/:sectionId',
        name: 'VideoPageDetail',
        component: VideoPageDetail,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },

      // Categories
      {
        path: '/categories/music',
        name: 'MusicCategoriesPage',
        component: MusicCategoriesPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/categories/missions',
        name: 'MissionCategoriesPage',
        component: MissionCategoriesPage,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      // Referral Data
      {
        path: '/referral-data/banner-click',
        name: 'ReferralDataBannerPage',
        component: ReferralDataBanner,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/referral-data/share-click',
        name: 'ReferralDataSharePage',
        component: ReferralDataShare,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/referral-data/referred-member',
        name: 'ReferralDataMemberPage',
        component: ReferralDataMember,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      // Referral Data
      {
        path: '/subscription/first-time-subs',
        name: 'FirstTimeSubsPage',
        component: FirstTimeSubs,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      {
        path: '/subscription/cancel-expired-subs',
        name: 'CancelExpireSubsPage',
        component: CancelExpireSubs,
        meta: { authorize: [ROLE.OPS, ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
      // CLTV
      {
        path: '/cltv',
        name: 'CLTVPage',
        component: CLTVPage,
        meta: { authorize: [ROLE.SUPERADMIN, ROLE.ADMINISTRATOR] },
      },
    ],
  },
  {
    path: '/register',
    name: 'Signup',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    // component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
    component: Signup,
  },
  {
    path: '/login',
    name: 'Signin',
    component: Signin,
  },
  {
    path: '/admin/login',
    component: SigninAdmin,
  },
  {
    path: '/verification-email',
    component: VerificationEmail,
    props: route => Object.assign({}, route.query, route.params),
  },
  {
    path: '/signup-success',
    component: SignupSuccess,
    name: 'SignupSuccess',
    props: route => Object.assign({}, route.query, route.params),
  },
  {
    path: '/send-verification',
    component: SendVerification,
    name: 'SendVerification',
    props: route => Object.assign({}, route.query, route.params),
  },
  {
    path: '/forgot-password',
    component: ForgotPassword,
    name: 'ForgotPassword',
    props: route => Object.assign({}, route.query, route.params),
  },
  {
    path: '/change-password',
    component: ChangePassword,
    name: 'ChangePassword',
    props: route => Object.assign({}, route.query, route.params),
  },
];

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  // redirect to login page if not logged in and trying to access a restricted page
  const publicPages = [
    '/login',
    '/register',
    '/admin/login',
    '/verification-email',
    '/signup-success',
    '/forgot-password',
    '/change-password',
    '/send-verification',
  ];
  const authRequired = !publicPages.includes(to.path);
  const loggedIn = localStorage.getItem('access_token');

  if (authRequired && !loggedIn) {
    return next('/login');
  }

  const { authorize } = to.meta;

  if (authorize) {
    const role = localStorage.getItem('role') || '';
    // check if route is restricted by role
    if (authorize.length && !authorize.includes('*') && !authorize.includes(role)) {
      if (role === ROLE.FINANCE) { return next('/payout-list'); }
      // role not authorised so redirect to home page
      return next({ path: '/' });
    }
  }

  return next();
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js